export default __webpack_public_path__ + "static/media/bubble_nova_background_m2.a9be5f58.jpg";